import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { nanoid } from 'nanoid'

import { RoutingPaths } from 'app/routes/routes.ts'

import { HotelImage } from 'shared/api/tours/search'
import EmptyImage from 'shared/images/empty-image.webp'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { ImageLazy } from 'shared/ui/image-lazy'

import s from './styles.module.scss'

interface LocationState {
  images: HotelImage[]
  title: string
}

const RoomGallery = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const location = useLocation()
  const state = location.state as LocationState | null

  if (!state?.images?.length) {
    return (
      <div className={s.container}>
        <HeaderGoBack
          buttonWhite
          variant={'grey'}
          title=""
        />
        <div className={s.empty}>
          <p>{t('tours_block.empty_images')}</p>
        </div>
      </div>
    )
  }

  const onClickImage = (index: number) => {
    navigate(RoutingPaths.tours.roomPreview.path(index), {
      state: {
        images: state.images,
        title: state.title,
      },
    })
  }

  return (
    <div className={s.container}>
      <HeaderGoBack
        buttonWhite
        variant={'grey'}
        title={state.title}
      />

      <div className={s.grid}>
        {state.images.map((item, index) => (
          <div
            className={s.imageWrapper}
            key={nanoid()}
            onClick={() => onClickImage(index)}
          >
            <ImageLazy
              src={item.src}
              alt={item.sort_index || String(index)}
              errorImage={EmptyImage}
              className={s.image}
            />
          </div>
        ))}
      </div>
    </div>
  )
}

export default RoomGallery
